import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useDispatch } from 'react-redux';
import { ocplcUploadFile } from 'actions/ocplcAction';

const UploadDialog = ({ open, handleClose, checkedRows, selectedCategory, selectKmat, productGroup, region, setCheckedRows,selectedIds,setSelectedIds }) => {
    const [files, setFiles] = useState([]);
    const dispatch = useDispatch();
    const fileInputRef = useRef();

    const addFiles = (newFiles) => setFiles(prev => [...prev, ...newFiles]);

    const handleFileChange = (e) => addFiles(e.target.files);

    const handleDrop = (e) => {
        e.preventDefault();
        addFiles(e.dataTransfer.files);
    };

    const handleDragOver = (e) => e.preventDefault();

    const handleUpload = async () => {
        if (files.length) await dispatch(ocplcUploadFile(files[0], checkedRows, selectedCategory, selectKmat, productGroup, region, setCheckedRows,handleClose,setSelectedIds));
        setFiles([]);
    };

    return open && (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Upload File</DialogTitle>
            <Typography sx={{ p: "20px 0 0 20px" }}>Upload file</Typography>
            <DialogContent
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
            >
                <label style={{ width: '100%' }}>
                    <TextField
                        type="text"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={files.length ? `${files.length} file(s) selected` : ''}
                        onClick={() => fileInputRef.current.click()}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        fileInputRef.current.click();
                                    }}
                                >
                                    <FileUploadOutlinedIcon />
                                </IconButton>
                            )
                        }}
                    />
                    <input
                        type="file"
                        accept=".xls,.xlsx,.csv"
                        hidden
                        multiple
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                </label>
                {!!files.length && (
                    <List>
                        {files.map((file) => (
                            <ListItem key={file.name}>
                                <ListItemText primary={file.name} />
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions sx={{ justifyContent: "flex-start", ml: "15px" }}>
                <Button variant="outlined" onClick={handleClose}>Close</Button>
                <Button
                    variant="contained"
                    disabled={!files.length}
                    onClick={handleUpload}
                >
                    Upload
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadDialog;